/**
 * @Description 地图loading效果
 */
import { FC, useEffect, useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';

interface LoadingProps{
  /** 地图实例 */
  amapIns:any;
  /**
   * 动画图
   * @default `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/new_map_page_loading2.gif`
   *  */
  gifUrl?:string;
  /**
   * @description loading延时取消时间
   * @default 300
   */
  delay?:number;
  /**
   * @description 文字提示
   * @default '地图内容加载中，请稍等'
   */
  text?:null|string;
}

// 默认gif，可自定义
const loadingGif = `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/new_map_page_loading2.gif`; // map_loading
const Loading: FC<LoadingProps> = ({
  amapIns, // 地图实例
  gifUrl = loadingGif, // 动画图
  delay = 300, // loading延时取消时间
  text = '地图内容加载中，请稍等'
}) => {
  const [pageLoading, setPageLoading] = useState<boolean>(true); // 默认显示loading

  useEffect(() => {
    if (!amapIns) return;
    setTimeout(() => {
      setPageLoading(false);
    }, delay);
  }, [amapIns]);

  return (
    <>
      {
        pageLoading ? <div className={styles.mapComOfLoadingCon}>
          <img
            src={gifUrl}
            width='100%'
            height='100%'/>
          {text && <div className={cs(styles.text, styles.stroke)}>{text}</div>}
        </div> : <></>
      }
    </>
  );
};

export default Loading;
